module.exports = __webpack_public_path__ + "img/gameit.04e7bdcc.webp";